import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  REPORT_TEMPLATE,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchReportTemplate = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_CUSTOMREPORT_TEMPLATE}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_CUSTOMREPORT_TEMPLATE}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_CUSTOMREPORT_TEMPLATE}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_CUSTOMREPORT_TEMPLATE}${query}${sorting}`);
};

const postReportTemplate = async ({ params }) => axiosAuthInstance.post(API_END_POINTS.ADD_CUSTOMREPORT_TEMPLATE, params);

export function* getReportTemplate(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    const { data: { entity } } = yield call(fetchReportTemplate, action.payload);
    yield put({ type: REPORT_TEMPLATE.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: REPORT_TEMPLATE.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* addReportTemplate(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postReportTemplate, action.payload);
    const { data: { entity } } = yield call(fetchReportTemplate, action.payload);
    yield put({ type: REPORT_TEMPLATE.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.REPORTTEMPLATE.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
